
import { convertDecimalWithComma, formatDate } from "@/app/infrastructures/misc/Utils";
import { StoSCController } from "@/app/ui/controllers/StoSCController";
import debounce from "lodash/debounce";
import { Options, Vue } from "vue-class-component";
import { printManifestStoSC, printSummary } from "./modules/generate";
@Options({
  components: {},
  computed: {
    getTitle() {
      return this.$route.meta.title;
    },
  },
})
export default class TabStoSC extends Vue {

  unmounted() {
    StoSCController.setSearch("");
  }

  //print label
  printSummary(id: number) {
    printSummary(id);
  }

  //print manifest
  printManifest(id: number) {
    printManifestStoSC(id);
  }

  //Filter Search
  onSearch = debounce((value: string) => {
    StoSCController.setSearch(value);
    StoSCController.setFirstPage();
    this.fetchSTOSCList();
  }, 250);

  clearSearch() {
    StoSCController.setSearch("");
    this.fetchSTOSCList();
  }

  get filterSTOSC() {
    return StoSCController.filterSTOSC;
  }
  get isLoading() {
    return StoSCController.isLoading;
  }
  get errorCause() {
    return StoSCController.errCause;
  }
  get stoSCList() {
    return StoSCController.stoSCList;
  }
  get search() {
    return StoSCController.search;
  }

  formatDateCreated(date: string) {
    return formatDate(date);
  }

  get highlightedData() {
    const result: any = [];
    this.stoSCList.data.forEach((key, index) => {
      if (key.stoScId === this.bundleManifestId.stoScId) {
        result.push(index);
      }
    });
    return result;
  }

  get bundleManifestId() {
    return StoSCController.manifestIdSTOSC;
  }

  fetchSTOSCList() {
    StoSCController.fetchSTOSCList();
  }

  //table
  get columns() {
    return [
      {
        name: this.$t("stoSc.table.columnNo"),
        styleHead: "w-12 text-left",
        render: (_: any, index: any) => {
          return `<div class="text-left">${
            index +
            1 +
            this.stoSCList.pagination.limit * (this.stoSCList.pagination.page - 1)
          }</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.manifestId"),
        styleHead: "w-32 text-left",
        render: (item: any) => {
          return `<div class="text-left">${item.stoScNo}</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.subConsolidatorName"),
        styleHead: "w-56 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="text-left">${item.subConsolidatorName}</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.totalStt"),
        styleHead: "w-24 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${item.totalSTT}</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.totalKoli"),
        styleHead: "w-28 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${item.totalPiece}</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.totalGrossWeight"),
        styleHead: "w-44 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${convertDecimalWithComma(
            item.totalGrossWeight,
            2
          )} ${this.$t("stoSc.common.unitKg")}</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.totalVolumeWeight"),
        styleHead: "w-44 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="overflow-ellipsis text-left">${convertDecimalWithComma(
            item.totalVolumeWeight,
            2
          )} ${this.$t("stoSc.common.unitKg")}</div>`;
        },
      },
      {
        name: this.$t("stoSc.table.stoScDate"),
        styleHead: "w-64 text-left whitespace-no-wrap",
        render: (item: any) => {
          return `<div class="flex flex-col overflow-ellipsis text-left"><span>${this.formatDateCreated(
            item.stoScDate
          )}</span> <span class="text-xs ${
            item.createdName ? "text-gray-lp-500" : "text-white"
          }">${item.createdName || this.$t("stoSc.common.userFallback")}</span></div>`;
        },
      },
      {
        name: this.$t("stoSc.table.action"),
        key: "button_column",
        styleHead: "w-24 text-left",
        styleButton: (item: any) => {
          return {
            outline: true,
            icon: "option-gray",
            title: "",
            textColor: "black",
            color: "gray-lp-400",
            customClass: "button-option",
            clickFunction: () => null,
            groupOptions: [
              {
                icon: "printer",
                label: this.$t("stoSc.list.printLabel"),
                clickFunction: () => this.printSummary(item.stoScId),
              },
              {
                icon: "printer",
                label: this.$t("stoSc.list.printManifest"),
                clickFunction: () => this.printManifest(item.stoScId),
              },
            ],
          };
        },
      },
    ];
  }
}
